import { types } from '../types'

const initialState = {
    WaitingPaidInvoice: false,
    SuccessPaidInvoice: false,
    ErrorPaidInvoice: '',
    paidInvoice: [],


    WaitingInvoiceInPOrtal: false,
    SuccessInvoiceInPOrtal: false,
    ErrorInvoiceInPOrtal: '',
    InvoiceInPOrtal: {},

    WaitingIssuType: false,
    SuccessIssuType: false,
    ErrorIssuType: '',
    IssuType: false,

}

const transactionReducer = (state = initialState, { type, action, error }) => {
    switch (type) {
        case types.GET_ALL_PAIED_INVOICE_REQUEST: {
              return {
                ...state,
                WaitingPaidInvoice: true,
                SuccessPaidInvoice: false,
                ErrorPaidInvoice: '',
                paidInvoice: [],
            }
        }
        case types.GET_ALL_PAIED_INVOICE_SUCCESS: {
            return {
                ...state,
                WaitingPaidInvoice: false,
                SuccessPaidInvoice: true,
                ErrorPaidInvoice: '',
                paidInvoice: action.data,
            }
        }
        case types.GET_ALL_PAIED_INVOICE_ERROR: {
            return {
                ...state,
                WaitingPaidInvoice: false,
                SuccessPaidInvoice: false,
                ErrorPaidInvoice: 'erroe',
                paidInvoice: [],
            }
        }



        case types.GET_INVOCE_IN_PORTAL_REQUEST: {
            return {
                ...state,
                WaitingInvoiceInPOrtal: true,
                SuccessInvoiceInPOrtal: false,
                ErrorInvoiceInPOrtal: '',
                InvoiceInPOrtal: {},
            }
        }
        case types.GET_INVOCE_IN_PORTAL_SUCCESS: {
            return {
                ...state,
                WaitingInvoiceInPOrtal: false,
                SuccessInvoiceInPOrtal: true,
                ErrorInvoiceInPOrtal: '',
                InvoiceInPOrtal: action.data,
            }
        }
        case types.GET_INVOCE_IN_PORTAL_ERROR: {
            return {
                ...state,
                WaitingInvoiceInPOrtal: false,
                SuccessInvoiceInPOrtal: false,
                ErrorInvoiceInPOrtal: 'error',
                InvoiceInPOrtal: {},
            }
        }

        case types.SET_ISSUTYPE_INVOICE_REQUEST: {
            return {
                ...state,
                WaitingIssuType: true,
                SuccessIssuType: false,
                ErrorIssuType: '',
                IssuType:false,
            }
        }
        case types.SET_ISSUTYPE_INVOICE_SUCCESS: {
            return {
                ...state,
                WaitingIssuType: false,
                SuccessIssuType: true,
                ErrorIssuType: '',
                IssuType:action.data,
            }
        }
        case types.SET_ISSUTYPE_INVOICE_ERROR: {
            return {
                ...state,
                WaitingIssuType: false,
                SuccessIssuType: false,
                ErrorIssuType: 'error',
                IssuType: false,
            }
        }


        case types.TRANSACTION_RESET_PROPS: {
            return {
                ...state,
                WaitingPaidInvoice: false,
                SuccessPaidInvoice: false,
                ErrorPaidInvoice: '',
                paidInvoice: [],


                WaitingInvoiceInPOrtal: false,
                SuccessInvoiceInPOrtal: false,
                ErrorInvoiceInPOrtal: '',
                InvoiceInPOrtal: {},

                WaitingIssuType: false,
                SuccessIssuType: false,
                ErrorIssuType: '',
                IssuType: false,
            }
        }
        //



        default:
            return state
    }
}

export default transactionReducer